export default __webpack_public_path__ + "static/gradebg3-5331fbf258d1109643e8360dc048d05a.png";